/**
 * @fileoverview Dropdown component for selecting blurb tone
 */

const TONE_OPTIONS = [
  { value: 'neutral', label: 'Neutral' },
  { value: 'agree', label: 'Agree' },
  { value: 'disagree', label: 'Disagree' },
  { value: 'skeptical', label: 'Skeptical' },
  { value: 'excited', label: 'Excited' },
];

export default function ToneSelector({ value = 'neutral', onChange, disabled = false, className = '' }) {
  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
      className={`px-2 py-1 text-xs border border-indigo-200 dark:border-indigo-700 rounded-md bg-white dark:bg-gray-900 text-gray-900 dark:text-gray-100 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 disabled:opacity-50 disabled:cursor-not-allowed ${className}`}
    >
      {TONE_OPTIONS.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
}
